const theme = {
  colors: {
    dark: '#2f3020',
    medium: '#596235',
    pale: '#cdcbd6',
    coral: '#d96846',
    hero: '#130e0c',
    bg: '#919879',
    star: '#ffbf00'
  },
  
  fontSize: {
    paragraph: '1.3em'
  }
}

export default theme;